<form #addCommentForm="ngForm" [ngClass]="{'disabled-content': loadingSpinner}">
	<div class="add-item-block">
		<div class="area-block">
			<!-- <textarea #punchItemTextArea class="text-area" matInput placeholder="Write a comment..." [required]="true"
				minlength="3" type="text" [(ngModel)]="itemDescription" name="itemDescription" [mention]="users"
				[mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}"></textarea> -->
			<textarea #punchItemTextArea class="text-area" matInput placeholder="Write a comment..." [required]="true"
				minlength="3" type="text" [(ngModel)]="itemDescription" name="itemDescription" [mention]="users"
				[mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}" (focus)="focusOnInput()"></textarea>
		</div>
		<div class="buttons-block">
			<button mat-button class="add-item-button" (click)="addComment()"
				[ngClass]="{'disabled-button': !addCommentForm.form.valid}" [disabled]="!addCommentForm.form.valid">
				<span *ngIf="!loadingSpinner">Add</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</div>
</form>
